import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { StringValidationRule, NumberValidationRule } from '../../../../data/validation/rules'

const getDefaultState = () => {
    return {
        creatingTourPackage: false,
        id: null,
        images: [],
        name: "",
        keyContents: Math.random(),
        contents: "",
        travelDate: "",
        duration: "",
        city: "",
        country: "",
        price: 0,
        status: 0,
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.name, (error) => errors.name = error, { min: { value: 2, error: "Too short" }, max: { value: 150, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.contents, (error) => errors.contents = error, { min: { value: 5, error: "Too short" }, max: { value: 100000, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.travelDate, (error) => errors.travelDate = error, { min: { value: 1, error: "Too short" }, max: { value: 50, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.duration, (error) => errors.duration = error, { min: { value: 1, error: "Too short" }, max: { value: 50, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.city, (error) => errors.city = error, { min: { value: 1, error: "Too short" }, max: { value: 100, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.country, (error) => errors.country = error, { min: { value: 1, error: "Too short" }, max: { value: 100, error: "Too long" } })
    validation.addValidationRule(NumberValidationRule, instance.state.price, (error) => errors.price = error, { min: { value: 0, error: "Too low" }, max: { value: 100000000, error: "Too high" } })
    validation.addValidationRule(NumberValidationRule, instance.state.status, (error) => errors.status = error, { min: { value: 0, error: "Too low" }, max: { value: 2, error: "Too high" } })
    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const createTourPackage = (instance) => {
    instance.setState({
        ...instance.state,
        creatingTourPackage: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/tour-package/create",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            name: instance.state.name,
            contents: instance.state.contents,
            travelDate: instance.state.travelDate,
            duration: instance.state.duration,
            city: instance.state.city,
            country: instance.state.country,
            price: instance.state.price,
            status: instance.state.status
        }
    }).then(response => handleCreateTourPackageResponse(instance, response.data))
    .catch(error => alert(error))
}

const handleCreateTourPackageResponse = (instance, response) => {
    if(response.status !== 200){
        return
    }
    switch (response.status) {
        case 200:
            instance.setState({
                ...getDefaultState(),
                flag: {
                    type: "success",
                    text: "Tour Package Created"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                creatingTourPackage: false,
                flag: {
                    type: "error",
                text: response.message
                }
            })
    }
}

const CreateTourPackageWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        createTourPackage: () => createTourPackage(instance)
    }
}

export default CreateTourPackageWorker
